__turbopack_context__.v({
  "crumbs": "tool-crumbs-module__rELC5a__crumbs",
  "visuallyHidden": "tool-crumbs-module__rELC5a__visuallyHidden",
});
